<!-- Summary -->
<mat-card class="padding-top">
  <mat-card-content>
    <div class="flex-container">
      <div class="flex-item">
        <div class="flex-container kv">
          <div class="flex-item kv-label text-faded">{{ labels.businessName }}</div>
          <div class="flex-item bold">{{ getString('name') }}</div>
        </div>

        @if (getString('legalName'); as legalName) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.legalName }}</div>
            <div class="flex-item">{{ legalName }}</div>
          </div>
        }

        @if (getString('translatedName'); as translatedName) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.translatedName }}</div>
            <div class="flex-item">{{ translatedName }}</div>
          </div>
        }
      </div>

      <div class="flex-item">
        <div class="flex-container kv">
          <div class="flex-item kv-label text-faded">{{ labels.number }}</div>
          <div class="flex-item bold">{{ getString('number') }}</div>
        </div>

        @if (getString('craNumber'); as cra) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.craNumber }}</div>
            <div class="flex-item">{{ cra }}</div>
          </div>
        }
      </div>
    </div>

    <div class="flex-container">
      <div class="flex-item">
        @if (getEnumString('normalizedEntityType'); as net) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.standardizedType }}</div>
            <div class="flex-item" style="display:flex;align-items:center;">
              <span style="margin-right:5px">
                <mat-icon color="primary">{{ getTypeIcon() }}</mat-icon>
              </span>
              {{ net | enumLabel:'normalizedEntityType' }}
            </div>
          </div>
        }

        <div class="flex-container kv">
          <div class="flex-item kv-label text-faded">{{ labels.registryType }}</div>
          <div class="flex-item">{{ getString('type') }}</div>
        </div>
      </div>

      <div class="flex-item">
        @if (getEnumString('normalizedStatus'); as ns) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.standardizedStatus }}</div>
            <div class="flex-item" style="display:flex;align-items:center;">
              <span style="margin-right:5px">
                <mat-icon [ngStyle]="getStatusIconColor()">{{ getStatusIcon() }}</mat-icon>
              </span>
              {{ normalizedStatusLabels[ns] ?? (ns | enumLabel:'normalizedStatus') }}
            </div>
          </div>
        }

        @if (getString('status'); as status) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.registryStatus }}</div>
            <div class="flex-item">{{ status }}</div>
          </div>
        }
      </div>
    </div>

    @if (getString('homeJurisdiction') || getString('registeredJurisdiction')) {
      <div class="flex-container">
        <div class="flex-item">
          @if (getString('homeJurisdiction'); as home) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ labels.homeJurisdiction }}</div>
              <div class="flex-item">{{ home }}</div>
            </div>
          }
          @if (getString('registeredJurisdiction'); as reg) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ labels.registeredJurisdiction }}</div>
              <div class="flex-item">{{ reg }}</div>
            </div>
          }
        </div>
        <div class="flex-item">
          <ng-container>
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded"></div>
              <div class="flex-item"></div>
            </div>
          </ng-container>
          <ng-container>
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded"></div>
              <div class="flex-item"></div>
            </div>
          </ng-container>
        </div>
      </div>
    }

    <div class="flex-container">
      <div class="flex-item">
        @if (getString('annualReturnDueDate'); as due) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.annualReturnDue }}</div>
            <div class="flex-item">{{ due | date: 'yyyy-MM-dd' }}</div>
          </div>
        }

        @if (getString('lastAnnualReturnFiledDate'); as filed) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.lastARFiled }}</div>
            <div class="flex-item">{{ filed | date: 'yyyy-MM-dd' }}</div>
          </div>
        }
      </div>

      <div class="flex-item">
        @if (getString('yearOfLastAnnualReturn'); as year) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.yearOfLastAR }}</div>
            <div class="flex-item">{{ year }}</div>
          </div>
        }

        @if (getString('annualReturnStatus'); as arStatus) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.annualReturnStatus }}</div>
            <div class="flex-item">{{ annualReturnStatusLabels[arStatus] ?? (arStatus | enumLabel:'annualReturnStatus') }}</div>
          </div>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>

<!-- Addresses (view-only) -->
<mat-card class="margin-top-25 flex-item">
  <mat-card-content>
    <h3 class="section-title">{{ labels.addresses }}</h3>

    @if (getArray('addresses'); as addresses) {
      @if (addresses.length === 0) {
        <div class="text-faded">{{ labels.noAddresses }}</div>
      }
      @for (address of addresses; track address; let i = $index; let last = $last) {
        <div class="address-entry">
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.type }}</div>
            <div class="flex-item">{{ addressTypeLabel(address) }}</div>
          </div>
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.fullAddress }}</div>
            <div class="flex-item">{{ getFrom(address, 'fullAddress') || '—' }}</div>
          </div>
          @if (!last) {
            <div class="light-divider"></div>
          }
        </div>
      }
    }
  </mat-card-content>
</mat-card>

<!-- Parties (view-only) -->
<mat-card class="margin-top-25 flex-item">
  <mat-card-content>
    <h3 class="section-title">{{ labels.parties }}</h3>

    @if (getArray('parties'); as parties) {
      @if (parties.length === 0) {
        <div class="text-faded">{{ labels.noParties }}</div>
      }
      @for (party of parties; track party; let i = $index; let last = $last) {
        <div class="party-group">
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ labels.type }}</div>
            <div class="flex-item">{{ partyTypeLabel(party) }}</div>
          </div>
          @if (getFrom(party, 'name')) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ labels.name }}</div>
              <div class="flex-item">{{ getFrom(party, 'name') || '—' }}</div>
            </div>
          }
          @if (getFrom(party, 'effectiveDate')) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ labels.effectiveDate }}</div>
              <div class="flex-item">{{ (getFrom(party, 'effectiveDate') | date: 'yyyy-MM-dd') || '—' }}</div>
            </div>
          }
          @if (getFrom(party, 'endDate')) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ labels.endDate }}</div>
              <div class="flex-item">{{ (getFrom(party, 'endDate') | date: 'yyyy-MM-dd') || '—' }}</div>
            </div>
          }
          @if (getCivicAddress(party)) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ labels.civicAddress }}</div>
              <div class="flex-item">{{ getCivicAddress(party) || '—' }}</div>
            </div>
          }
          @if (!last) {
            <div class="light-divider"></div>
          }
        </div>
      }
    }
  </mat-card-content>
</mat-card>
